export default __webpack_public_path__ + "static/media/Beard_11_C4.5895f654.svg";